import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLaunchDarkly } from '../../launchdarkly';
import { PlanV2 } from './PlanV2';
import { LoadingProgress } from '../../layout';
import { fromOrder, fromSubscription, useAppDispatch } from '../../store';

export const Plan = () => {
  const { initialized } = useLaunchDarkly();
  const dispatch = useAppDispatch();
  const subscriptionLoading = useSelector(fromSubscription.selectLoading);

  useEffect(() => {
    dispatch(fromOrder.resetOrderPreviewResponse());
  }, []);

  if (!initialized || subscriptionLoading) {
    return <LoadingProgress fullscreen />;
  }

  return <PlanV2 />;
};
